<template>
  <div class="outter-modal">
    <div class="modal fade show" style="display: block; overflow: scroll" tabindex="-1">
      <div :class="modalClasses">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">
              <slot name="header">
                {{' '}}
              </slot>
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" @click="$emit('close')">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <slot />
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop" />
  </div>
</template>

<script>
export default {
  name: 'ModalDialog',
  props: {
    msize: {
      type: String,
      default: 'modal-xl',
    },
  },
  computed: {
    modalClasses() {
      return 'modal-dialog modal-dialog-centered ' + this.msize;
    },
  },
};
</script>

<style lang="scss" scoped>
.outter-modal {
  position: absolute;
  z-index: 1089;
}
</style>
